import { MenuItem, Box, Typography } from '@mui/material';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { CustomSelect, CustomTextField, CustomCheckbox, CustomButton } from '../../../common';
import { useLastArcaInvoiceDate } from '../../../hooks/useInvoices';
import { useEffect, useRef } from 'react';

const RegisterPaymentFilters = ({
  filter,
  handleFilter,
  selectedDate,
  setSelectedDate,
  selectedCobroDate,
  setSelectedCobroDate,
  entidadSeleccionada,
  setEntidadSeleccionada,
  selectedSalePoint,
  handleSalePointChange,
  makeElectronicInvoice,
  setMakeElectronicInvoice,
  handleClearAll,
  plans,
  recLegalEntities,
  salePoints,
  isNaranjaX,
}) => {
  const filterStyles = {
    width: { xs: '100%', sm: '48%', md: '32%' },
    mb: { xs: 1, md: 0 },
  };

  const { data: lastArcaDate } = useLastArcaInvoiceDate();

  const prevMakeElectronic = useRef(makeElectronicInvoice);

  useEffect(() => {
    if (lastArcaDate && makeElectronicInvoice) {
      setSelectedDate(lastArcaDate);
    }
  }, [lastArcaDate, makeElectronicInvoice, setSelectedDate]);

  useEffect(() => {
    if (!lastArcaDate) {
      prevMakeElectronic.current = makeElectronicInvoice;
      return;
    }

    if (makeElectronicInvoice && !prevMakeElectronic.current) {
      if (!selectedDate) {
        setSelectedDate(lastArcaDate);
        prevMakeElectronic.current = makeElectronicInvoice;
        return;
      }
    }

    if (makeElectronicInvoice) {
      try {
        const sel = new Date(selectedDate);
        const minDate = new Date(lastArcaDate);
        if (!selectedDate || sel < minDate) {
          setSelectedDate(lastArcaDate);
        }
      } catch (e) {
      }
    }

    prevMakeElectronic.current = makeElectronicInvoice;
  }, [makeElectronicInvoice, lastArcaDate, selectedDate, setSelectedDate]);

  const isSelectedDateOlderThanFiveDays = (() => {
    if (!selectedDate) return false;
    try {
      const sel = new Date(selectedDate);
      const today = new Date();

      const selMid = new Date(sel.getFullYear(), sel.getMonth(), sel.getDate());
      const todayMid = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const diffMs = todayMid - selMid;
      if (diffMs < 0) return false;
      const FIVE_DAYS_MS = 5 * 24 * 60 * 60 * 1000;
      return diffMs > FIVE_DAYS_MS;
    } catch (e) {
      return false;
    }
  })();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          mb: 2,
          width: '100%',
        }}
      >
        <CustomTextField
          label="Fecha Factura"
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          size="medium"
          shrinkLabel={true}
          sx={filterStyles}
          inputProps={
            makeElectronicInvoice && lastArcaDate
              ? { min: lastArcaDate }
              : undefined
          }
        />

        {!isNaranjaX && (
          <CustomTextField
            label="Fecha Cobro"
            type="date"
            value={selectedCobroDate}
            onChange={(e) => setSelectedCobroDate(e.target.value)}
            size="medium"
            shrinkLabel={true}
            sx={filterStyles}
          />
        )}

        <CustomSelect
          label="Plan"
          value={filter.plan}
          onChange={handleFilter}
          name="plan"
          size="medium"
          sx={filterStyles}
        >
          {plans.map((plan) => (
            <MenuItem key={plan.uuid} value={plan.uuid}>
              {plan.name}
            </MenuItem>
          ))}
        </CustomSelect>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          width: '100%',
        }}
      >
        <CustomSelect
          label="Entidad Recaudadora"
          value={entidadSeleccionada}
          onChange={(e) => setEntidadSeleccionada(e.target.value)}
          size="medium"
          sx={filterStyles}
        >
          {recLegalEntities.map((entidad) => (
            <MenuItem key={entidad.uuid} value={entidad.uuid}>
              {entidad.legal_business_name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Punto de venta"
          value={selectedSalePoint?.uuid || ''}
          onChange={handleSalePointChange}
          size="medium"
          sx={filterStyles}
        >
          {salePoints?.map((punto, index) => (
            <MenuItem key={index} value={punto.uuid}>
              {punto.number}
            </MenuItem>
          ))}
        </CustomSelect>

        {selectedSalePoint?.invoice === true && (
          <CustomCheckbox
            checked={makeElectronicInvoice}
            onChange={(e) => setMakeElectronicInvoice(e.target.checked)}
            name="noGenerarCAE"
            label="Generar CAE"
            sx={{
              width: { xs: '100%', sm: '48%', md: '32%' },
              mb: { xs: 1, md: 0 },
            }}
          />
        )}

        {makeElectronicInvoice && lastArcaDate && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', mb: 1 }}>
            <Typography variant="body2" color="textSecondary">
              La última factura en ARCA se generó el día {lastArcaDate}.
            </Typography>
            {isSelectedDateOlderThanFiveDays && (
              <Typography variant="body2" color="warning.main" sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                Se recomienda revisar la Fecha de factura; es anterior por más de 5 días respecto a la fecha actual.
              </Typography>
            )}
          </Box>
        )}

        <CustomButton
          variant="warning"
          size='fullWidth'
          buttonIcon={CleaningServicesIcon}
          onClick={handleClearAll}
          sx={{
            width: '100%',
          }}
        >
          Limpiar Formulario
        </CustomButton>
      </Box>
    </>
  );
};

export default RegisterPaymentFilters;
